// extracted by mini-css-extract-plugin
export default {"btnBox":"JoinRequests_btnBox__G+ygk"};